import axiosInsAcademy from '@/api/axios-ugems-academy';
import { GET_COURSE_BY_ID } from '@/api/master-data/course-catalog/course-catalog';

export default {
  // Get all courses for Mitra TNA Report - PJO role
  getCoursesPJO(params) {
    return axiosInsAcademy.get('/tna/partner/courses/pjo', { params });
  },

  // Get all courses for Mitra TNA Report - HSE role
  getCoursesHSE(params) {
    return axiosInsAcademy.get('/tna/partner/courses/hse', { params });
  },

  // Get summary
  getSummary(params) {
    return axiosInsAcademy.get('/tna/partner/summary', { params });
  },

  // Get summary
  getSummaryHSE(params) {
    return axiosInsAcademy.get('/tna/hse/summary', { params });
  },

  // Get course detail - using course-catalog API
  getCourseDetail(id) {
    return GET_COURSE_BY_ID(id);
  },

  // Get mandatoried employees for a course
  getMandatoriedEmployees(courseId) {
    return axiosInsAcademy.get(`/tna/partner/courses/${courseId}/mandatoried-employees`);
  },

  // Get submitted participants for a course
  getSubmittedParticipants(courseId, params) {
    return axiosInsAcademy.get(`/tna/partner/courses/${courseId}/submitted`, { params });
  },

  getSubmittedParticipantsApproveByPJO(courseId, params) {
    return axiosInsAcademy.get(`/tna/partner/courses/${courseId}/approve-by-pjo`, { params });
  },

  // Approve participants by PJO
  approveByPJO(courseId, tnaIds, options = {}) {
    return axiosInsAcademy.put(`/tna/partner/courses/${courseId}/approve-by-pjo`, {
      approved: tnaIds,
      ...options
    });
  },

  // Approve participants by HSE
  approveByHSE(courseId, tnaIds, options = {}) {
    return axiosInsAcademy.put(`/tna/partner/courses/${courseId}/approve-by-hse`, {
      approved: tnaIds,
      ...options
    });
  },

  // Reject participants by PJO
  rejectByPJO(courseId, tnaIds) {
    return axiosInsAcademy.put(`/tna/partner/courses/${courseId}/reject-by-pjo`, {
      tna_ids: tnaIds
    });
  },

  // Reject participants by HSE
  rejectByHSE(courseId, tnaIds) {
    return axiosInsAcademy.put(`/tna/partner/courses/${courseId}/reject-by-hse`, {
      tna_ids: tnaIds
    });
  },

  // Get companies list
  getCompanies(params) {
    return axiosInsAcademy.get('/companies', { params });
  },

  // Download template for bulk upload by NIK
  downloadTemplateByNik() {
    return axiosInsAcademy.get('/contractor-training-mappings/bulk-download-template-by-nik', {
      responseType: 'blob'
    });
  },

  // Bulk create contractor training mappings by NIK
  bulkCreateByNik(formData) {
    return axiosInsAcademy.post('/contractor-training-mappings/bulk-create-by-nik', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};
